<template>
	<Container>
		<TopBar />
		<div class='load' v-show='showLoading'>
			<loading />
		</div>
		<div class='paymentPage' v-if='!showLoading'>
			<div class="top">
				<div v-if="$route.query.paystatus == 'yes'">
					<div class="logo">
						<div class="shadow">
							<img src="@/assets/order/success.png">
						</div>
					</div>
					<h2>支付完成(Payment Completed)</h2>
				</div>
				<div v-if="$route.query.paystatus == 'no'">
					<div class="">
						<div class="shadow">
							<img src="@/assets/order/failed.png">
						</div>
					</div>
					<h2 style="color: #ff3838;">支付失敗(Payment Failed)</h2>
					<h2 style="color: #ff3838;" v-if="$route.query.type == 'Visa' || $route.query.type == 'Mastercard' || $route.query.type == 'unionpay'">交易不成功請聯絡發卡銀行<br>If the transaction is unsuccessful, please contact the issuing bank</h2>
					<h2 style="color: #ff3838;" v-if="$route.query.type == 'wechat'">交易不成功請聯絡微信<br>If the transaction is unsuccessful, please contact wechat</h2>
					<h2 style="color: #ff3838;" v-if="$route.query.type == 'alipay' || $route.query.type == 'alipay_hk'">交易不成功請聯絡支付寶<br>If the transaction is unsuccessful, please contact alipay</h2>
				</div>
				<!-- <p class="newPc" v-if='isnew'>恭喜您,您的顧客編號為 :{{orderStatus.VipNo}}</p> -->
			</div>
			<div class="mid">
				<div class="orderNo">
					<b>NO:&nbsp;{{$route.query.os}}</b>
					<span v-if="$route.query.paystatus == 'yes'">已付款(Pay)</span>
					<span v-if="$route.query.paystatus == 'no'">未付款(unpaid)</span>
				</div>
				<div class="info">
					<div class="item">
						<span>訂單來源(Order Source):香港訂購(Hong Kong Order)</span>
						<span>HK${{desc.pay_fee.toFixed(2)}}</span>
					</div>
					<div class="item">
						<span>訂單類型(Order Type):{{desc.catalog=='LRP'?'LRP':'Standard'}}</span>
						<span>PV:{{desc.total_pv.toFixed(2)}}</span>
					</div>
					<div class="item">
						<span>聯絡電話(Contact Number):{{passwordTel}}</span>
						<!-- <span>積分:{{desc.ar_value.toFixed(2)}}</span> -->
					</div>
				</div>
				<div class="info address" v-if='selectdesc&&selectdesc.code=="501"&&desc.virtual_flag!=10'>
					<div class="item">
						<span>收貨人(Consignee):</span>
						<span>{{selectdesc.name}} </span>
					</div>
					<div class="item">
						<span>聯絡方式(Contact Information):</span>
						<span>{{selectdesc.moblie_phone}}</span>
					</div>
					<div class="item">
						<span>詳細地址(Contact Address):</span>
						<span>{{selectdesc.province}} {{selectdesc.city}} {{selectdesc.street}} {{selectdesc.street2}}</span>
					</div>
					<div class="item">
						<span class="update">*請確認配送地址無誤，如單一發貨訂單可於2小時內修改發貨地址。<br>
						Please confirm that the delivery address is correct. If it is single order, you are able to modify delivery address within 2 hours</span>
						<span class="update"><b @click="changeAddress">修改地址(Edit Address)</b></span>
					</div>
				</div>
				<div class="total">
					共{{productCount}}件商品({{productCount}} sets in total) 合計(Total)：HK${{desc.pay_fee.toFixed(2)}}&nbsp;(含運費 Delivery Fee Included HK${{desc.delivery_fee.toFixed(2)}})
				</div>
			</div>
			<div class="showlrp-hint" v-if='status&&showLRPTTip'>
				<section class="intro" v-html='Content'>
				</section>
			</div>
			<div class="foot">
				<!-- <Button size='large' v-if='status&&showLRPTTip' type="primary" shape="circle" @click="createLRP">創建LRP輕鬆購</Button> -->
				<Button size='large' type="primary" shape="circle" @click="continuePay" v-if="$route.query.paystatus == 'no' && orderStatus && (orderStatus.OrderStatuss=='UnPay' || orderStatus.OrderStatuss=='Paying')">重新支付(Repay)</Button>
				<Button size='large' type="primary" shape="circle" @click="goOrderList">我的訂單(My Order)</Button>
				<Button size='large' type="primary" shape="circle" @click="confrimPay" v-if="$route.query.paystatus == 'yes'">繼續購物(Continue Shopping)</Button>
			</div>
		</div>
		<editAddressView title='修改收貨人' :editAddress='editAddress' :show='show' @confirm='asyncOK' @cancel='show=false' :loading='addressLoading'></editAddressView>
		<paperBag :value='bagShow' :name='(showList[showIndex]||{}).Name' :time='(showList[showIndex]||{}).CreateTime' :pic='(showList[showIndex]||{}).Pic' :styles='(showList[showIndex]||{}).StyleWap' @close='colsePag'></paperBag>
	</Container>
</template>

<script>
import TopBar from "@/components/common/TopBar";
import { api_methods } from "@/service/loadData";
import editAddressView from "@/components/order/editAddressView";
import paperBag from "@/components/order/paperBag";
import loading from "@/components/order/loading";
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import { cvoUrl } from "@/config/env";

export default {
	data() {
		return {
			showLoading: true,
			status: false,
			isnew: false,
			orderStatus: null,
			is_charitable: false,
			Content: null,
			updateLoad: false,
			desc: null,
			selectdesc: null,
			list: [],
			editAddress: {
				id: 0,
				name: null,
				province_id: null,
				moblie_phone: null,
				city_id: null,
				county_id: null,
				town_id: null,
				street: null,
				street2: null,
				zip: null,
				email: null,
				wechatno: null,
				is_default: "0",
				tag_type: "0",
				address_type: "1",
			},
			show: false,
			addressLoading: false,
			bagShow: false,
			showList: [],
			showIndex: 0,
		};
	},
	created() {
		this.$nextTick(function () {
			if (this.$route.query.os) {
				this.initData(this.$route.query.orderno, this.$route.query.os);
			}
		});
	},
	mounted() {},
	watch: {},
	mixins: [],
	components: {
		TopBar,
		loading,
		editAddressView,
		paperBag,
	},
	computed: {
		...mapGetters(["bogo_switch", "getAccessToken", "getVipNo",'newActivity']),
		...mapState({
			pay: (state) => state.order.payrecord,
			userInfo: (state) => state.common.wechatUserInfo.value,
		}),
		showLRPTTip() {
			return (
				this.userInfo.binding.customer_type.toLowerCase() != "rt" &&
				!this.userInfo.lrp_id &&
				!this.isnew
			);
		},
		passwordTel: function () {
			if (
				this.selectdesc.moblie_phone &&
				this.selectdesc.moblie_phone.length >= 11
			) {
				return this.selectdesc.moblie_phone.replace(
					/(\d{3})\d{4}(\d{4})/,
					"$1****$2"
				);
			} else {
				return this.selectdesc.moblie_phone;
			}
		},
		productText: function () {
			if (this.list && this.list.length > 0) {
				return (
					"【doTERRA】" +
					this.list[0].name +
					(this.list[0].specification || "")
				);
			}
			return "暫無信息";
		},
		productCount: function () {
			if (this.list && this.list.length > 0) {
				return this.list.length;
			}
			return 0;
		},
		isOrderbtn: function () {
			if (this.desc) {
				var flag = this.desc.virtual_flag;
				if (flag == 1 || flag == 2 || flag == 10) {
					return true;
				}
			}
			return false;
		},
		virtual_flag: function () {
			if (this.desc && this.desc.virtual_flag == 10) {
				return false;
			}
			return true;
		},
	},
	methods: {
		...mapActions([
			"getOrderStatusAction",
			"getTipDetailAction",
			"changeOrderAddressAction",
			"checkCharitableOrder",
			"postAddAddressAction",
			"checkQuestionnaireAction",
			"getCustomerRewardsAction",
			'getOrderEncryptionAction'
		]),
		...mapMutations(["SET_ORDERNN"]),
		async initData(orderNo, os) {
			console.log(this.$route.query)
			let res = await this.getOrderStatusAction(os);
			console.log(res)
			if (res) {
				this.orderStatus = res;
				if (this.orderStatus.PayStatus == "1") {
					//支付成功
					await this.initProductOrder();
					this.status = true;
					//判斷是否新用戶
					//this.SAVE_USER_TIME();
					if (
						this.orderStatus &&
						this.orderStatus.IsNewCustomer == 1
					) {
						this.isnew = true;
					}
					var res_lrp = await this.getTipDetailAction("createLRP");
					if (res_lrp) {
						this.Content = res_lrp.Content;
					}
				} else {
					//付款失敗
					await this.initProductOrder();
					this.status = false;
				}
				this.showLoading = false;
			}
			if (this.status) {
				this.getCustomerRewards(os,this.orderStatus.VipNo)
				await this.charitaleOrder(os);
				// if (!(await this.Questionnaire())) {
				// 	await this.showPCTip();
				// }
			}
			this.showLoading = false;
		},
		async getCustomerRewards(orderNo, vipNo) {
			if (this.newActivity) {
				var res = await this.getCustomerRewardsAction({
					orderNo,
					vipNo,
				});
				if (res && res.code > 0) {
					this.$Modal.info({
						title: "提示",
						content:res.message,
					});
				}
			}
		},
		async showPCTip() {
			await this.sleep(500);
		},
		async charitaleOrder(orderNo) {
			var res = await api_methods.checkCharitableOrder(
				this.getAccessToken,
				this.getUserId,
				orderNo
			);
			if (res && res.data && res.response.code == "1") {
				var arry = res.data.value.v;
				if (arry && arry[0]) {
					this.showList = arry;
					this.showIndex = 0;
					this.bagShow = true;
				}
			}
		},
		async Questionnaire() {
			var code = 0;
			if (!this.bogo_switch) {
				var ret = await this.checkQuestionnaireAction();
				if (ret == 1) {
					code = 1;
					//調用API 是否顯示
					this.$Modal.confirm({
						title: "顧客問卷調查(Customer Survey)",
						content: "邀請您參加顧客問卷調查",
						okText: "開始(Start)",
						cancelText: "忽略(Ignore)",
						onOk: async () => {
							var redirect = `${cvoUrl}/vo/index.html#/s/index?channel=vo`;
							window.open(redirect);
							await this.showPCTip();
						},
						onCancel: async () => {
							await this.showPCTip();
						},
					});
				}
			}
			return code;
		},
		async initProductOrder() {
			//加載修改地址數據
			//if (!this.selectdesc) {
			let { orderno, os } = this.$route.query;

			var yz = await api_methods.getProductOrder(
				this.getAccessToken,
				this.getUserId,
				orderno,
				this.userInfo.binding.user_id,
				1,
				os
			);
			console.log(yz)
			if (yz && yz.data && yz.response.code == "1") {
				var model = yz.data.value;
				this.desc = model.desc;
				this.selectdesc = model.delivery;
				this.list = model.product;
			}
			//}
		},
		async continuePay() {
			var res = await this.getOrderEncryptionAction(
				this.$route.query.os
			);
			if (res) {
				this.SET_ORDERNN({
					orderno: res,
					os: this.$route.query.os
				});
				this.$router.push("/order/confirm");
			}
		},
		confrimPay() {
			this.$router.push("/order/product");
		},
		async asyncOK(address) {
			this.addressLoading = true;
			var obj = {
				Id: address.id,
				Name: address.name,
				MobliePhone: address.moblie_phone,
				Province: address.province_id,
				City: address.city_id,
				County: address.county_id,
				Town: address.town_id,
				Street: address.street,
				Street2: address.street2,
				Zip: address.zip,
				Email: address.email,
				WechatNo: address.wechatno,
				AddressType: address.address_type,
				Tags: address.tag_type,
				IsDefault: address.is_default ? 1 : 0,
				CustomerId: this.userInfo.binding.user_id,
				orderNo: this.$route.query.os,
				Remark: "",
			};
			let response = await this.changeOrderAddressAction(obj);
			if (response > 0) {
				if (address.whetherAddress) {
					await this.postAddAddressAction(obj);
				}
				this.initProductOrder();
				this.$Message.success("地址修改成功");
				//this.selectdesc=null;
				// this.$Modal.success({
				// 	title: "提示",
				// 	content: "地址修改成功",
				// 	onOk: () => {
				// 		this.$router.push("/wxorders");
				// 	}
				// });
				//await this.initData(this.$route.query.orderno,this.$route.query.os)
			} else {
				let message = "";
				if (response == -1) {
					message =
						"訂單不存在或者訂單已經發貨或者已經取消不可以修改";
				} else if (response == -2) {
					message = "訂單正在處理中，請稍後修改";
				} else {
					message = "地址修改失敗";
				}
				this.$Message.error(message);
			}
			this.show = false;
			this.addressLoading = false;
		},
		checkAddress() {
			if (this.selectdesc) {
				if (
					this.desc.s < 0 ||
					this.desc.order_status.toLowerCase() == "cancel"
				) {
					return "訂單修改地址時間超時,或已取消";
				}
				if (this.selectdesc.code != "501") {
					return "精油生活館自提不能調整地址哦";
				}
			} else {
				return "獲取數據失敗";
			}
		},
		async changeAddress() {
			this.updateLoad = true;
			await this.initProductOrder();
			var msg = this.checkAddress();
			if (!msg) {
				this.editAddress = {
					id: 0,
					orderNo: this.$route.query.os,
					name: this.selectdesc.name,
					province_id: parseInt(this.selectdesc.province_id),
					city_id: parseInt(this.selectdesc.city_id),
					county_id: parseInt(this.selectdesc.county_id),
					town_id: parseInt(this.selectdesc.town_id),
					street: this.selectdesc.street,
					street2: this.selectdesc.street2,
					zip: this.selectdesc.zip,
					email: this.selectdesc.email,
					wechatno: this.selectdesc.wechatno,
					moblie_phone: this.selectdesc.moblie_phone,
					address_type: 2,
					tag_type: "",
					is_default: false,
					whetherAddress: false,
				};
				this.show = true;
			} else {
				this.$Modal.error({
					title: "提示",
					content: msg,
				});
			}
			this.updateLoad = false;
		},
		createLRP() {
			location = `${cvoUrl}/vo/index.html#/mine/choosePeriod?token=${this.getAccessToken}&source=HK`;
		},
		async colsePag() {
			this.bagShow = false;
			await this.sleep(500);
			if (this.showList[this.showIndex + 1]) {
				this.showIndex = this.showIndex + 1;
				this.bagShow = true;
			}
		},
		goOrderList() {
			this.$router.push({
				path: "/order/orders",
				// query: {
				// 	from: "merge",
				// },
			});
		},
	},
};
</script>

<style lang='scss' scoped>
@import "@/style/common";
@import "@/style/mixin";
.load {
	width: 100%;
	//margin: 40px auto;
	margin-bottom: 30px;
	overflow: hidden;
	height: 350px;
	position: relative;
}
.paymentPage {
	width: 70.03vw;
	margin: 40px auto;
	margin-bottom: 30px;
	overflow: hidden;
}
.top {
	text-align: center;
	margin: auto;
	margin-top: 30px;
	.logo {
		margin: auto;
		width: 150px;
		border-radius: 200px;
		box-shadow: 1px 1px 20px #dddddd8c;
		height: 150px;
		text-align: center;
		line-height: 210px;
		background: $green;
		img {
			width: 55px;
		}
	}
	h2 {
		color: $green;
		margin-top: 20px;
	}
	.time {
		margin-top: 20px;
		span {
			padding: 5px;
			background-color: $theme-color;
			display: inline-block;
			color: white;
		}
		i {
			font-style: normal;
			@include fontSize($font-size-13);
			margin: 0 5px;
		}
		b {
			font-weight: 500;
			margin-right: 5px;
		}
	}
	p {
		margin-top: 20px;
	}
}
.showlrp-hint {
	width: 41.53vw;
	margin: auto;
	margin-top: 20px;
	p {
		@include fontSize($font-size-16);
		padding: 5px;
		color: $theme-color;
	}
	button {
		background-color: #bc86c8;
		color: white;
		margin: 10px 0;
	}
	.intro {
		background-color: white;
		margin-top: 0.5px;
		//padding:2px 0.55px;
		padding-top: 0.5px;
		@include fontSize($font-size-16);
		h3 {
			@include fontSize($font-size-16);
		}
		p {
			margin-top: 0.1px;
			@include fontSize($font-size-16);
			color: black;
		}
	}
}
.mid {
	width: 40.03vw;
	margin: auto;
	margin-top: 20px;
	.orderNo {
		border-bottom: 1px solid #dedede;
		height: 30px;
		b {
			float: left;
		}
		span {
			float: right;
			padding: 1px 10px;
			border: 1px solid $theme-color;
			color: $theme-color;
			@include fontSize($font-size-13);
			border-radius: 10px;
		}
	}
	.info {
		border-bottom: 1px solid #dedede;
		.item {
			// height: 30px;
			line-height: 30px;
			overflow: hidden;
			span:nth-of-type(2) {
				color: $theme-color;
				float: right;
			}
		}
		&.address {
			span:nth-of-type(2) {
				color: #636363;
				float: right;
			}
			span.update {
				b {
					color: $theme-color;
					font-weight: 800;
					cursor: pointer;
				}
			}
		}
	}
	.total {
		margin-top: 10px;
		font-weight: 500;
	}
	.payList {
		.item {
			cursor: pointer;
			padding: 10px 0;
			border-bottom: 1px solid #dedede;
			img:nth-of-type(1) {
				width: 50px;
			}
			img:nth-of-type(2) {
				float: right;
				width: 25px;
				margin-top: 10px;
			}
		}
	}
}
.foot {
	margin-top: 30px;
	text-align: center;
	button {
		// width: 150px;
		margin-right: 10px;
	}
}
.newPc {
	color: $theme-color;
	// font-weight: 800;
	//color: red;
	@include fontSize($font-size-17);
}

@media (max-width: 768px) {
	.paymentPage {
		width: 90%;
		font-size: 0.65rem;
	}
	.mid {
		width: 100%;
	}
}
</style>